/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, max: NonNullable<unknown> }} Shop_Home_Count_SlidesInputs */

const vi_shop_home_count_slides = /** @type {(inputs: Shop_Home_Count_SlidesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}/${i?.max} slide`)
};

/**

* @param {Shop_Home_Count_SlidesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_count_slides = /** @type {((inputs: Shop_Home_Count_SlidesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Count_SlidesInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_count_slides(inputs)
});